module.exports = __webpack_public_path__ + "static/media/play-button-type.7115867c.png";